import {keys} from 'lodash'
import {useEffect, useState} from 'react'
import {
  DEVICE_TYPE_OFFICE,
  Hours,
  officeDeviceDefaultHours,
  remoteDeviceDefaultHours
} from '../constants'

export const OperationalHours = props => {
  const {type, onChange = () => {}, operationalHours} = props

  const defaultHours = type === DEVICE_TYPE_OFFICE ? officeDeviceDefaultHours : remoteDeviceDefaultHours

  const [days, setDays] = useState(operationalHours)

  useEffect(() => {
    setDays(operationalHours)
  }, [operationalHours])

  useEffect(() => {
    onChange(days)
  }, [days])

  const addHour = index => {
    const _d = [...days]
    _d[index].hours.push(defaultHours)
    setDays(_d)
  }

  const removeHour = (dayIndex, hourIndex) => {
    const _days = [...days]
    _days[dayIndex].hours.splice(hourIndex, 1)
    setDays(_days)
  }

  const hourChange = (event, dayIndex, hourIndex, hourType) => {
    const _days = [...days]
    const _day = {..._days[dayIndex]}
    _day.hours[hourIndex][hourType] = Number(event.target.value)
    _days.splice(dayIndex, 1, _day)
    setDays(_days)
  }

  const handleActivation = (event, dayIndex) => {
    const _days = [...days]
    const _day = {..._days[dayIndex]}
    _day.active = event.target.checked
    _days.splice(dayIndex, 1, _day)
    setDays(_days)
  }

  const toggleHourTimingMode = index => {
    const _days = [...days]
    if (_days[index].is24Hours) {
      _days.splice(index, 1, {
        ..._days[index],
        is24Hours: false,
        hours: [defaultHours]
      })
    } else {
      _days.splice(index, 1, {
        ..._days[index],
        is24Hours: true,
        hours: [{from: 0, to: 24}]
      })
    }
    setDays(_days)
  }

  return (
    <table className="vw-table vw-table--sm">
      <thead>
        <tr>
          <th>Day</th>
          <th>Time on</th>
          <th>Time off</th>
          <th colSpan="2"></th>
          <th>off/on</th>
        </tr>
      </thead>
      <tbody>
        { days && days.map((day, index) => (
          <tr key={`${day.day}-${index}`} className={!day?.active ? 'vw-table__muted' : ''}>
            <td>{day.day}</td>
            <td className="px-1">
              {day.hours.map((hours, hourIndex) => (
                <select
                  key={`${day.day}-from-${index}-${hourIndex}`}
                  onChange={e => hourChange(e, index, hourIndex, 'from')}
                  className="form-control my-2"
                  disabled={day.is24Hours || !day.active}
                  value={hours.from}
                >
                  { keys(Hours).map(h => (
                    <option
                      key={`${day.day}-${h}-hour-from-${hourIndex}`}
                      value={h}
                      selected={hours.from === h}
                    >
                      { Hours[h] }
                    </option>
                  ))}
                </select>
              ))}
            </td>

            <td className="px-1">
              {day.hours.map((hours, hourIndex) => (
                <select
                  key={`${day.day}-to-${index}-${hourIndex}`}
                  onChange={e => hourChange(e, index, hourIndex, 'to')}
                  className="form-control my-2"
                  disabled={day.is24Hours || !day.active}
                  value={hours.to}
                >
                  {keys(Hours).map(h => (
                    <option
                      key={`${day.day}-${h}-hour-to-${hourIndex}`}
                      value={h}
                      selected={hours.to === h}
                    >
                      { Hours[h] }
                    </option>
                  ))}
                </select>
              ))}
            </td>

            <td>
              <button
                type="button"
                className={['btn btn-link text-decoration-none d-block', day.is24Hours ? 'disabled' : '']}
                onClick={() => addHour(index)}
              >
                <i className="fal fa-plus"></i>
                <span className="ml-1">Add new time</span>
              </button>

              {day.hours.map((_hours, hourIndex) =>
                hourIndex !== 0 ? (
                  <button
                    key={`${day.day}-remove-${index}`}
                    type="button"
                    className="btn btn-link text-decoration-none d-block"
                    onClick={() => removeHour(index, hourIndex)}
                  >
                    <i className="fal fa-minus"></i>
                    <span className="ml-1">Remove time</span>
                  </button>
                ) : null
              )}
            </td>

            <td>
              <button
                type="button"
                className="btn btn-link text-decoration-none"
                onClick={() => toggleHourTimingMode(index)}
              >
                <i className="fal fa-clock"></i>
                <span className="ml-1">{day.is24Hours ? 'Set Custom Time' : 'Make 24 hour'}</span>
              </button>
            </td>

            <td>
              <input
                type="checkbox"
                data-check="1"
                checked={day.active}
                className="form-toggle tr-toggle"
                onChange={e => handleActivation(e, index)}
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}
